// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';
import { localize } from '@ta/common.i18n';
import { connect } from 'react-redux';
import type { ViewportCategory, State as GlobalState } from '@ta/common.state';
import { Track } from '@ta/common.tracking';

import MobileValuePropositionSkeleton from './MobileValuePropositionSkeleton';
import DesktopValuePropositionSkeleton from './DesktopValuePropositionSkeleton';
import styles from './ValueProposition.less';

type ExternalProps = {
  /** extra class names for the wrapper of the shelf */
  className?: string,
};

type Props = ExternalProps & {
  viewportCategory: ViewportCategory,
  pageName: string,
};

const ValueProposition = (props: Props) => (
  <Track
    mount={{
      module: 'AttractionValueProposition',
      action: 'value_proposition_shown',
      context: props.pageName,
    }}
  >
    <div className={classNames(props.className, styles.ValueProposition)}>
      <div className={styles.title}>
        {localize('ibex_Why_Book_on_TripAdvisor_1bd8') /* Why Book on TripAdvisor? */}
      </div>
      {props.viewportCategory !== 'MOBILE' && <DesktopValuePropositionSkeleton />}
      {props.viewportCategory === 'MOBILE' && <MobileValuePropositionSkeleton startIndex={0} />}
    </div>
  </Track>
);

const mapStateToProps = (state, externalProps: ExternalProps) => ({
  ...externalProps,
  viewportCategory: state.meta.device.viewportCategory,
  pageName: state.route.page ? state.route.page : '',
});

export default connect<Props, ExternalProps, _, _, GlobalState, _>(mapStateToProps)(
  ValueProposition,
);
